import { memo } from "react";
import { ChatPaperclipIcon } from "components/shared/svg-action-icons";
import { formatFileSize } from "../utils/formatFileSize";

const ChatComposerFilePreview = ({
  t,
  selectedFile,
  previewUrl,
  onRemoveFile,
  isCompact,
}) => {
  if (!selectedFile) return null;

  return (
    <div
      className={`inline-flex items-center gap-2.5 bg-surface border border-border-muted rounded-[10px] shadow-[0_3px_4px_rgba(0,0,0,0.03)] w-fit max-w-[230px] ${
        isCompact ? "px-2 py-1.5" : "px-2.5 py-2"
      }`}
    >
      {previewUrl ? (
        <div
          className={`flex-shrink-0 rounded-[7px] bg-cover bg-center border border-border-light ${
            isCompact ? "w-8 h-8" : "w-9 h-9"
          }`}
          style={{ backgroundImage: `url(${previewUrl})` }}
        />
      ) : (
        <div
          className={`flex-shrink-0 rounded-[7px] icon-primary-wrap flex items-center justify-center ${
            isCompact ? "w-8 h-8" : "w-9 h-9"
          }`}
        >
          <ChatPaperclipIcon
            className={isCompact ? "w-4 h-4" : "w-4.5 h-4.5"}
          />
        </div>
      )}

      <div className="min-w-0 leading-tight">
        <div
          className={`font-semibold text-text-strong truncate ${
            isCompact
              ? "text-[11.5px] max-w-[130px]"
              : "text-[12.5px] max-w-[150px]"
          }`}
        >
          {selectedFile.name}
        </div>
        {selectedFile.size ? (
          <div
            className={`text-text-muted ${isCompact ? "text-[10px]" : "text-[10.5px]"}`}
          >
            {formatFileSize(selectedFile.size)}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        onClick={onRemoveFile}
        title={t("chat.remove_file")}
        className="flex-shrink-0 flex items-center justify-center w-[22px] h-[22px] rounded-[6px] bg-surface-muted text-dark hover:bg-border-muted hover:text-danger transition"
      >
        <span className="text-[13px] leading-none">✕</span>
      </button>
    </div>
  );
};

export default memo(ChatComposerFilePreview);
